import Side from './Side';
import Content from './Content';
import style from '../css/Report.module.css';
import React, { useState, useContext } from 'react';
import axios from 'axios';
import { TokenContext } from "./TokenContext";
import Loader from './Loader';

function ViewContainer({ jsonData }) {
    const [pdfUrl, setPdfUrl] = useState(null); // PDF URL 상태 관리
    const { bearerToken, _csrf } = useContext(TokenContext); // Context 사용

    const [loading, setLoading] = useState(false); // 로딩 상태
    const [error, setError] = useState(null); // 에러 상태

    const handleGeneratePDF = async (bodyData) => {
        setLoading(true); // 로딩 시작
        setError(null); // 이전 에러 초기화

        // endpoint : /report/api/getData/generate-report
        // method : post
        // body : { userId, layoutType }
        const endpoint = "/report/api/getData/generate-report"; // 가상의 서버 주소

        try {
            const response = await axios.post(endpoint,
                bodyData,
                {
                    withCredentials: true, // 쿠키 포함 옵션
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${bearerToken}`,
                        'x-csrf-token': `${_csrf}`,
                    }
                });

            const data = await response.data;
            if (data.result) { // 성공 상태 확인
                const getUrl = data.data; // 서버에서 반환된 PDF URL
                setPdfUrl(`${getUrl}`); // 서버에서 받은 PDF URL 설정
                //window.open(`http://localhost:3030${getUrl}`, '_blank');          
            } else {
                alert('PDF 생성에 실패했습니다.');
            }
        } catch (error) {
            console.error('PDF 요청 중 오류 발생:', error);
            setError(error.message || 'PDF 요청 중 오류 발생'); // 
        } finally {
            setLoading(false); // 로딩 종료
        }
    }

    if(error) {
        // console.error(error);
    }

    return (
        <div className={style.viewContainer}>
            {loading && <Loader />}
            <Side
                handleGeneratePDF={handleGeneratePDF}
                jsonData={jsonData.jsonData}
                pdfUrl={pdfUrl}
            />
            <Content
                pdfUrl={pdfUrl}
            />
        </div>
    );
}

export default ViewContainer;